const SearchStatus = {
	PAUSED: 'PAUSED',
	ACTIVE: 'ACTIVE',
	DELETED: 'DELETED',
};

module.exports = SearchStatus;
